import request from './request'

// 首页
export function getIndex() {
  return request({
    url: '/yp/index',
    method: 'get',
  })
}

// 产品中心
export function getProduct() {
  return request({
    url: '/yp/productCenter',
    method: 'get',
  })
}

// 产品分类
export function getCat() {
  return request({
    url: '/yp/cat',
    method: 'get',
  })
}

//关于我们
export function getAbout() {
  return request({
    url: '/yp/aboutUs',
    method: 'get',
  })
}

// 联系我们
export function getContact() {
  return request({
    url: '/yp/contactUs',
    method: 'get',
  })
}

// 合作伙伴
export function getPartner() {
  return request({
    url: '/yp/partner',
    method: 'get',
  })
}

// 新闻资讯
export function getNews() {
  return request({
    url: '/yp/news',
    method: 'get',
  })
}
